import React from 'react';
import PropTypes from 'prop-types';
import stylesGlobal from 'theme/facility-globals.scss';
import { compose } from 'utils/react';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';
import style from './LocationsNearYou.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const LocationsNearYou = ({ children }) => {
  const [widget] = React.Children.toArray(children);

  return (
    <div className={`${stylesGlobal.section} ${style.wholeSection}`}>
      {widget}
    </div>
  );
};

LocationsNearYou.propTypes = propTypes;

const component = compose(
  section(
    { name: 'Locations Near You', category: 'Locations' },
    { subsections: [
      { accepts: ['LocationsNearYou'] },
    ],
    defaults: ['LocationsNearYou'],
    },
  ),
)(LocationsNearYou);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
